export const WATCHLIST_LOAD = "WATCHLIST_LOAD";
export const WATCHLIST_SUCCESS = "WATCHLIST_SUCCESS";
export const WATCHLIST_ERROR= "WATCHLIST_ERROR";

export const RECENTLY_VIEWED_SUCCESS = "RECENTLY_VIEWED_SUCCESS";
export const RECENTLY_VIEWED_DELETE= "RECENTLY_VIEWED_DELETE";

export const SORT_YEAR_ASC = "SORT_YEAR_ASC";
export const SORT_YEAR_DESC = "SORT_YEAR_DESC";


export const SORT_IMDBRATING_ASC = "SORT_IMDBRATING_ASC";
export const SORT_IMDBRATING_DESC = "SORT_IMDBRATING_DESC";

export const SORT_RUNTIME_ASC = "SORT_RUNTIME_ASC";
export const SORT_RUNTIME_DESC = "SORT_RUNTIME_DESC";


export const SORT_LISTORDER_ASC = "SORT_LISTORDER_ASC";
export const SORT_LISTORDER_DESC = "SORT_LISTORDER_DESC";


export const SORT_DEFAULT = "SORT_DEFAULT";

export const EDITWATCHLIST_SUCCESS = "EDITWATCHLIST_SUCCESS";